import React, { useEffect, useState, useCallback } from 'react';
import Menu from "../../comum/Menu";
import Footer from "../../comum/Footer";
import { api } from '../../services/api';
import Swal from 'sweetalert2';
import { NumericFormat } from 'react-number-format';
import {
    FaCalculator, FaHistory, FaClock,
    FaExclamationTriangle, FaTrashAlt, FaWallet, FaCheckCircle
} from 'react-icons/fa';
import './index.css';

const Assistencia = () => {
    const chapa = localStorage.getItem("chapa");

    const [historico, setHistorico] = useState([]);
    const [simulacoes, setSimulacoes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [emAberto, setEmAberto] = useState(false);
    const [valorSolicitado, setValorSolicitado] = useState(1000);
    const [solicitacaoPendente, setSolicitacaoPendente] = useState(null);
    const [dadosUsuario, setDadosUsuario] = useState({
        salario: 0,
        valor_permitido: 0,
        loja: 0,
        assistpend: 0
    });

    const formatCurrency = (val) =>
        new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val || 0);

    const carregarDados = useCallback(async () => {
        setLoading(true);
        try {
            // 1. Busca dados do usuário (Loja, Salário e Flag de Pendência)
            const userRes = await api.get(`/usuario/dados/${chapa}`);
            let vPendenteDB = 0;

            if (userRes.data && userRes.data[0]) {
                const data = userRes.data[0];
                vPendenteDB = data.assistpend || 0;

                setDadosUsuario({
                    salario: data.salario || 0,
                    loja: data.loja || 0,
                    valor_permitido: data.assistlimite || (data.salario * 0.8),
                    assistpend: vPendenteDB
                });
            }

            // 2. Busca histórico/extrato
            const res = await api.get(`/aeflor/assistencia/extrato/${chapa}`);
            setHistorico(res.data);

            // 3. Verifica se há algo pendente (status 1 no extrato ou valor no assistpend)
            const pendenteNoExtrato = res.data.find(item => item.status === 1);

            if (vPendenteDB > 0 || pendenteNoExtrato) {
                setEmAberto(true);
                setSolicitacaoPendente(pendenteNoExtrato || { valor_emp: vPendenteDB });
                setValorSolicitado(vPendenteDB || pendenteNoExtrato?.valor_emp);
            } else {
                setEmAberto(false);
                setSolicitacaoPendente(null);
            }

        } catch (err) {
            console.error("Erro ao carregar dados:", err);
        } finally {
            setLoading(false);
        }
    }, [chapa]);

    useEffect(() => {
        carregarDados();
    }, [carregarDados]);

    const handleSimular = async () => {
        if (!valorSolicitado || valorSolicitado < 100) {
            Swal.fire("Atenção", "Insira um valor mínimo de R$ 100,00", "info");
            return;
        }

        try {
            const res = await api.get(`/aeflor/assistencia/simular/${valorSolicitado}?salario=${dadosUsuario.salario}`);
            setSimulacoes(res.data);

            if (valorSolicitado > dadosUsuario.valor_permitido) {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                });
                Toast.fire({
                    icon: 'warning',
                    title: 'Valor acima do permitido. Sujeito a análise especial.'
                });
            }
        } catch (err) {
            Swal.fire("Erro", "Falha ao processar simulação.", "error");
        }
    };

    const handleCancelar = async () => {
        const valorExibir = dadosUsuario.assistpend || solicitacaoPendente?.valor_emp || 0;

        const result = await Swal.fire({
            title: 'Cancelar Solicitação?',
            text: `Deseja remover sua solicitação pendente de ${formatCurrency(valorExibir)}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Sim, cancelar',
            cancelButtonText: 'Sair'
        });

        if (result.isConfirmed) {
            try {
                await api.delete(`/aeflor/assistencia/cancelar/${chapa}`);
                Swal.fire("Cancelado!", "Solicitação removida com sucesso.", "success");

                // Reset local para permitir nova simulação
                setSimulacoes([]);
                setEmAberto(false);
                carregarDados();
            } catch (err) {
                Swal.fire("Erro", "Não foi possível cancelar no momento.", "error");
            }
        }
    };

    const handleSolicitar = async (op) => {
        const { value: motivo } = await Swal.fire({
            title: 'Confirmar Envio',
            html: `
                <div style="text-align:left; background: #f8f9fa; padding: 15px; border-radius: 8px; margin-bottom: 15px">
                    <div style="font-size:14px; color: #444">
                        Valor: <b>${formatCurrency(valorSolicitado)}</b><br/>
                        Parcelas: <b>${parseInt(op.parcela)}x de ${formatCurrency(op.valparcela)}</b><br/>
                        Total com Juros: <b>${formatCurrency(op.total)}</b>
                        ${valorSolicitado > dadosUsuario.valor_permitido ? '<br/><span style="color:red; font-size:11px">⚠️ Valor excede o limite padrão</span>' : ''}
                    </div>
                </div>
                <div style="text-align:left">
                    <label style="font-size: 11px; font-weight: bold; color: #666">MOTIVO DA SOLICITAÇÃO:</label>
                    <textarea id="motivo" class="swal2-textarea" placeholder="Descreva o motivo..." style="height:90px; margin-top: 5px"></textarea>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Confirmar e Enviar',
            confirmButtonColor: '#198754',
            preConfirm: () => {
                const texto = document.getElementById('motivo').value;
                if (!texto || texto.trim().length < 5) {
                    Swal.showValidationMessage('O motivo é obrigatório (min. 5 caracteres)');
                    return false;
                }
                return texto;
            }
        });

        if (!motivo) return;

        try {
            await api.post('/aeflor/assistencia/solicitar', {
                matricula: parseInt(chapa),
                valor: valorSolicitado,
                parcelas: parseInt(op.parcela),
                motivo: motivo,
                salario: dadosUsuario.salario,
                loja: dadosUsuario.loja || 0,
                juros: op.juros,
                fator: op.fator,
                valor_total: op.total,
                valor_permitido: dadosUsuario.valor_permitido
            });

            Swal.fire("Solicitado!", "Seu pedido foi enviado para análise do RH.", "success");
            setSimulacoes([]);
            carregarDados();
        } catch (err) {
            Swal.fire("Erro", "Erro ao processar solicitação.", "error");
        }
    };

    return (
        <div style={{ background: 'linear-gradient(180deg,#f4f6f9 0%,#eef2f7 100%)', minHeight: '100vh' }}>
            <Menu modulo="ARBOR" />

            <div className="container py-4">
                <div className="row justify-content-center">
                    <div className="col-12 col-xl-10">

                        <div className="mb-4">
                            <h4 className="fw-bold d-flex align-items-center mb-1">
                                <FaCalculator className="text-primary me-2" />
                                Assistência Financeira
                            </h4>
                            <small className="text-muted">Simule e solicite sua assistência AEFLOR de forma rápida.</small>
                        </div>

                        {loading ? (
                            <div className="text-center p-5"><div className="spinner-border text-primary"></div></div>
                        ) : (
                            <>
                                <div className="row mb-5 justify-content-center">
                                    <div className="col-12 col-md-8 col-lg-7">
                                        <div className="card border-0 shadow-lg" style={{ borderRadius: '16px' }}>
                                            <div className="card-body p-4">

                                                <div className="info-financeira mb-4">
                                                    <div className="row g-0">
                                                        <div className="col-6 p-3 border-end text-center">
                                                            <label className="label-cap d-block mb-1">Seu Salário</label>
                                                            <div className="d-flex align-items-center justify-content-center text-dark fw-bold">
                                                                <FaWallet className="me-2 text-muted" size={14} />
                                                                {formatCurrency(dadosUsuario.salario)}
                                                            </div>
                                                        </div>
                                                        <div className="col-6 p-3 text-center">
                                                            <label className="label-cap d-block mb-1">Valor Permitido</label>
                                                            <div className="d-flex align-items-center justify-content-center text-success fw-bold">
                                                                <FaCheckCircle className="me-2" size={14} />
                                                                {formatCurrency(dadosUsuario.valor_permitido)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <label className="label-cap mb-2">Valor da Assistência</label>
                                                <div className="d-flex flex-column flex-md-row gap-2 mb-3">
                                                    <div className="flex-grow-1">
                                                        <NumericFormat
                                                            className={`form-control form-control-lg fw-bold ${emAberto ? 'bg-light text-muted' : 'border-primary'}`}
                                                            style={{ fontSize: '1.4rem', textAlign: 'center' }} // Fonte grande e centralizada
                                                            value={valorSolicitado}
                                                            onValueChange={(v) => setValorSolicitado(v.floatValue)}
                                                            thousandSeparator="."
                                                            decimalSeparator=","
                                                            prefix="R$ "
                                                            disabled={emAberto}
                                                        />
                                                    </div>

                                                    {emAberto ? (
                                                        <button
                                                            className="btn btn-danger fw-bold d-flex align-items-center justify-content-center py-2 py-md-0 px-4"
                                                            onClick={handleCancelar}
                                                        >
                                                            <FaTrashAlt className="me-2" /> Cancelar Pedido
                                                        </button>
                                                    ) : (
                                                        <button
                                                            className="btn btn-primary fw-bold py-2 py-md-0 px-5"
                                                            onClick={handleSimular}
                                                            style={{ fontSize: '1.1rem' }}
                                                        >
                                                            Simular
                                                        </button>
                                                    )}
                                                </div>

                                                {emAberto && (
                                                    <div className="alert-pendente">
                                                        <div className="alert-pendente-icon">
                                                            <FaExclamationTriangle />
                                                        </div>

                                                        <div className="alert-pendente-content">
                                                            <div className="alert-pendente-title">
                                                                Em análise
                                                            </div>

                                                            <div className="alert-pendente-text">
                                                                Você possui uma solicitação de
                                                                <span className="alert-pendente-valor">
                                                                    {formatCurrency(valorSolicitado)}
                                                                </span>
                                                                em análise pela <span className="alert-pendente-valor">AEFLOR</span>.
                                                                <br></br>Cancele se quiser alterar o valor ou desistir da assitência.
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {!emAberto && (
                                                    <div className="mt-3">
                                                        {simulacoes.map((s, i) => (
                                                            <div key={i} className={`sim-card ${parseInt(s.parcela) > 6 || valorSolicitado > dadosUsuario.valor_permitido ? 'sim-warning' : ''}`}>
                                                                <div className="d-flex justify-content-between align-items-center flex-wrap">
                                                                    <div className="mb-2 mb-sm-0">
                                                                        <div className="fw-bold text-dark" style={{ fontSize: '1.1rem' }}>
                                                                            {parseInt(s.parcela)}x de {formatCurrency(s.valparcela)}
                                                                        </div>
                                                                        <small className="text-muted d-block">Total: {formatCurrency(s.total)}</small>
                                                                    </div>
                                                                    <button className="btn btn-success fw-bold px-3" onClick={() => handleSolicitar(s)}>Solicitar</button>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <h5 className="fw-bold mb-3 d-flex align-items-center">
                                    <FaHistory className="me-2 text-secondary" /> Histórico de assistências
                                </h5>
                                <div className="row">
                                    {historico.length === 0 && <div className="col-12 text-muted ps-4 small">Nenhum registro encontrado.</div>}
                                    {historico.map((h, i) => (
                                        <div key={i} className="col-12 col-md-6 mb-3">
                                            <div className="card border-0 shadow-sm h-100 card-hover" style={{ borderRadius: '12px' }}>
                                                <div className="card-body">
                                                    <div className="d-flex justify-content-between mb-3">
                                                        <span className="badge bg-light text-dark border">ID: {parseInt(h.codemprestimo)}</span>
                                                        <span className={`fw-bold small status-${h.status}`}>
                                                            {h.status === 1 ? '● Pendente' : h.status === 2 ? '● Ativo' : '● Cancelado'}
                                                        </span>
                                                    </div>

                                                    <div className="row g-2 mb-2">
                                                        <div className="col-4">
                                                            <label className="label-cap">Início</label>
                                                            <div className="fw-bold small text-dark">
                                                                {h.dt_emp ? new Date(h.dt_emp).toLocaleDateString('pt-BR') : '--/--/--'}
                                                            </div>
                                                        </div>
                                                        <div className="col-4 text-center">
                                                            <label className="label-cap">Fim</label>
                                                            <div className="fw-bold small text-dark">
                                                                {h.dt_fim ? new Date(h.dt_fim).toLocaleDateString('pt-BR') : '--/--/--'}
                                                            </div>
                                                        </div>
                                                        <div className="col-4 text-end">
                                                            <label className="label-cap">Taxa de Contribuição (a.m)</label>
                                                            <div className="fw-bold small text-primary">
                                                                {h.juros ? `${parseFloat(h.juros).toFixed(2)}%` : '0,00%'}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row g-2 border-top pt-2">
                                                        <div className="col-6">
                                                            <label className="label-cap">Valor Solicitado</label>
                                                            <div className="fw-bold text-secondary" style={{ fontSize: '0.9rem' }}>
                                                                {formatCurrency(h.valor_emp)}
                                                            </div>
                                                        </div>
                                                        <div className="col-6 text-end">
                                                            <label className="label-cap">Total c/ Contribuição</label>
                                                            <div className="fw-bold text-success" style={{ fontSize: '1rem' }}>
                                                                {formatCurrency(h.valor_total)}
                                                            </div>
                                                        </div>
                                                        <div className="col-12 mt-1">
                                                            <div className="bg-light p-2 rounded text-center">
                                                                <span className="text-muted small">
                                                                    Pagamento em <b>{parseInt(h.parcelas)}x</b> de <b>{formatCurrency(h.valor_total / h.parcelas)}</b>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <Footer />

            <style>{`
                .label-cap { font-size:10px; text-transform:uppercase; color:#888; font-weight:700; letter-spacing:0.5px; }
                .info-financeira { background: #fcfcfc; border: 1px solid #eee; border-radius: 12px; overflow: hidden; }
                .card-hover { transition: 0.2s; }
                .card-hover:hover { transform: translateY(-3px); box-shadow: 0 10px 20px rgba(0,0,0,0.08) !important; }
                .sim-card { border: 1px solid #f0f0f0; border-radius: 12px; padding: 15px; margin-bottom: 12px; background: #fff; }
                .sim-warning { border-left: 5px solid #ffc107 !important; background: #fffdf5; }
                .status-1 { color: #f39c12; }
                .status-2 { color: #27ae60; }
                .status-3 { color: #e74c3c; }
            `}</style>
        </div>
    );
};

export default Assistencia;